import { render, staticRenderFns } from "./SrContactEdit.vue?vue&type=template&id=beace278&"
import script from "./SrContactEdit.vue?vue&type=script&lang=js&"
export * from "./SrContactEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports